import { get, post, remove } from 'api';
import { LOAD_FAILED_ORDERS_PARAMS } from 'appConstants';

import {
  FAILED_ORDERS_LOADED,
  FAILED_ORDERS_SYNC_ERROR,
  FAILED_ORDER_REMOVED,
  FAILED_ORDER_REMOVE_ERROR,
  LOAD_FAILED_ORDERS,
  REMOVE_FAILED_ORDER,
  SYNC_RESENDED_ORDER,
} from './actionTypes';

export const initialActionsState = {
  loadFailedOrders: () => {},
  removeFailedOrder: () => {},
  resendFailedOrder: () => {},
  syncResentOrder: () => {},
};

export const getActions = (dispatch: {
  (value: { type: any; payload?: any }): void;
  (arg0: { type: string; payload?: any }): void;
}) => ({
  loadFailedOrders: async () => {
    dispatch({
      type: LOAD_FAILED_ORDERS,
    });

    const { data, error } = await get('/cp/orders', {
      params: {
        status: LOAD_FAILED_ORDERS_PARAMS.STATUS,
        limit: LOAD_FAILED_ORDERS_PARAMS.LIMIT,
      },
    });

    const payload = data || [];

    if (!error) {
      dispatch({
        type: FAILED_ORDERS_LOADED,
        payload,
      });
    } else {
      dispatch({
        type: FAILED_ORDERS_SYNC_ERROR,
        payload: error,
      });
    }
  },
  removeFailedOrder: async (internalOrderId: string, onDone) => {
    dispatch({
      type: REMOVE_FAILED_ORDER,
    });

    const { error } = await remove(`cp/orders/${internalOrderId}`);

    if (!error) {
      dispatch({
        type: FAILED_ORDER_REMOVED,
        payload: internalOrderId,
      });
    } else {
      dispatch({
        type: FAILED_ORDER_REMOVE_ERROR,
        payload: error,
      });
    }

    if (onDone) onDone(error);
  },
  syncResentOrder: async (
    orderId: string,
    publishStatus: string,
    publishDate: string,
    onDone?: (data?) => void,
  ) => {
    const { data, error } = await get(`cp/orders/${orderId}`);

    if (
      data &&
      !error &&
      (data['publishStatus'] !== publishStatus || data['publishDate'] !== publishDate)
    ) {
      dispatch({
        type: SYNC_RESENDED_ORDER,
        payload: data,
      });
    }
    if (onDone) {
      onDone(data);
    }
  },
  resendFailedOrder: async (internalOrderId: string, onDone: (error) => void) => {
    const { error } = await post(`cp/send-order/${internalOrderId}`, {});
    if (onDone) onDone(error);
  },
});
